import { render, staticRenderFns } from "./callLogsList.vue?vue&type=template&id=3027ea71&scoped=true"
import script from "./callLogsList.vue?vue&type=script&lang=js"
export * from "./callLogsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3027ea71",
  null
  
)

export default component.exports